import React, { useState } from "react";

import api from "../services/api";
import useAxios from "../hooks/useAxios";
import axiosInstance from "../apis/gvmdesk";

//components
import Input from "../components/Input";
import Button from "../components/Button";
import Select, { Option } from "../components/Forms/Select";

import { useForm } from "react-hook-form";
import { useAuth } from "../providers/auth";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate, useParams } from "react-router-dom";

import * as yup from "yup";
import openToast from "../utils/sweetAlert";

const schema = yup.object().shape({
  dateStart: yup.date().nullable()
    .transform((curr, orig) => orig === "" ? null : curr).required("O campo data é obrigatório."),
  dateLimit: yup.date().nullable()
    .transform((curr, orig) => orig === "" ? null : curr).required("O campo data é obrigatório."),
  admin_caregiver: yup.string().required("É necessário selecionar um campo acima!")
});

const VacationTool = props => {
  const [loading, setLoading] = useState(false);

  const params = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const { register, reset, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });
  const token = { headers: { "Authorization": "Bearer " + user.token } };

  const [admins, setAdmins, admloading, error, refetch] = useAxios({
    axiosInstance,
    method: "GET",
    url: "/admins/list"
  });

  const onSubmit = async data => {
    setLoading(true);

    try {
      const vacation = {
        admin_caregiver: data.admin_caregiver,
        admin_vacation: params.id,
        dateLimit: data.dateLimit,
        dateStart: data.dateStart
      }

      const response = await api.post("/admins/vacation/start", vacation, token);

      if (!response.data.error) {
        openToast("success", "Sucesso", response.data.message);
        navigate("/vacation-tool");
      }

      if (response.data.error) {
        openToast("error", "Erro", response.data.message);
      }
    } catch (e) {
      openToast("error", "Erro", "Ocorreu um erro");
    } finally {
      setLoading(false);
      reset();
    }
  };

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <span>Ferramenta de férias</span>
      </div>

      <div className="u-d-flex flex-column justify-content-center align-center u-mt-100">
        <div className="white-box mt-1">

          <form onSubmit={handleSubmit(onSubmit)}>
            <Select label="Quem ficará responsável" type="text" name="admin_caregiver"
              register={register} error={errors.admin_caregiver}>
              {admins?.map(admin => <Option key={admin.id} value={admin.id}>{admin.name}</Option>)}
            </Select>

            <Input label="Data de entrada" type="date" placeholder="00/00/00"
              name="dateStart" register={register} error={errors.dateStart} />

            <Input label="Data de saída" type="date" placeholder="00/00/00"
              name="dateLimit" register={register} error={errors.dateLimit} />

            <Button type="submit" title="Salvar" color="green" width="full" styles="mt-20" loading={loading} />
          </form>
        </div>
      </div>
    </div>
  );
}

export default VacationTool;